<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useUserInfoStore } from '@/stores/modules/user'
import AppLogo from './components/AppLogo.vue'
import AppMenu from './components/AppMenu.vue'
import AppHeader from './components/AppHeader.vue'
import AppLabelNav from './components/AppLabelNav.vue'

const userStore = useUserInfoStore()

const windowWidth = ref(window.innerWidth)
const isMobile = computed(() => windowWidth.value < 768)
const drawerVisible = ref(false)

const handleResize = () => {
  windowWidth.value = window.innerWidth
  if (!isMobile.value) {
    drawerVisible.value = false
  }
}

onMounted(() => window.addEventListener('resize', handleResize))
onUnmounted(() => window.removeEventListener('resize', handleResize))

const handleMenuSelect = () => {
  if (isMobile.value) {
    drawerVisible.value = false
  }
}
</script>
<template>
  <div class="app-layout">
    <el-container>
      <!-- 桌面端：固定侧边栏 -->
      <el-aside v-if="!isMobile" class="app-sider-bar" :style="{ width: userStore.collapse ? '64px' : '200px' }">
        <AppLogo />
        <AppMenu />
      </el-aside>

      <!-- 移动端：抽屉式侧边栏 -->
      <el-drawer
        v-if="isMobile"
        v-model="drawerVisible"
        direction="ltr"
        :size="'220px'"
        :show-close="false"
        :with-header="false"
        class="mobile-drawer"
      >
        <AppLogo />
        <AppMenu @select="handleMenuSelect" />
      </el-drawer>

      <el-container>
        <el-header class="app-header">
          <AppHeader :is-mobile="isMobile" @toggle-drawer="drawerVisible = !drawerVisible" />
        </el-header>
        <el-main class="app-main">
          <div class="app-lab-nav">
            <AppLabelNav />
          </div>
          <div class="app-page">
            <!-- 页面 -->
            <RouterView v-slot="{ Component }">
              <transition name="fade">
                <KeepAlive :max="10">
                  <component :is="Component"></component>
                </KeepAlive>
              </transition>
            </RouterView>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<style scoped lang="scss">
.app-layout {
  @apply h-screen w-full;
  overflow: hidden;
  :deep(.el-container) {
    @apply h-full;
  }
}
.app-sider-bar {
  @apply h-full border-r-[1px] overflow-x-hidden flex flex-col transition-[width] duration-300;
}
.app-header {
  @apply h-[64px] flex-shrink-0;
}
.app-main {
  @apply bg-gray-50 p-[10px] flex flex-col;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter-active {
  transition-delay: 0.3s;
}
</style>

<style>
/* 移动端抽屉样式 */
.mobile-drawer .el-drawer__body {
  padding: 0;
  overflow-x: hidden;
}
</style>
